import { actions } from './actions';

const FailureReportReducers = {
    [actions.APPLY_SELECTED_FAILURE_REPORT]: (state, action) => { return { ...state, failureReportSelected: action.failureReportSelected } },
}

export default FailureReportReducers;